import type { ReactNode } from "react";
import type { WincheMarkProps } from "./brand";

/*
 * Where the W that moves plugs in (spec 07 › Momentos de marca, motion F19):
 * `brand-live.tsx` registers here when its module loads. It comes with
 * `useWorkSignal` (so with AiTask), never in the boot, whose marks never
 * move; a dynamic import in WincheMark cost the start-up more than the live W
 * itself (its preload list, and the shared chunks it split). Apart from
 * brand.tsx so that file exports only components (Fast Refresh), and only
 * brand's importers import it, so it travels in brand's chunk.
 */
export const markPlug: { live?: (props: WincheMarkProps) => ReactNode } = {};

export function plugLiveMark(mark: (props: WincheMarkProps) => ReactNode): void {
  markPlug.live = mark;
}
